import { post } from '@nbx/frontend-helpers/fetch-api';
import { context } from '@nbx/frontend-helpers/auth';
import setupDataFetcher from 'helpers/setupDataFetcher';

let baseUrl = 'accounts';

const NBXAccounts = {
  init: config => ({ baseUrl } = config),

  getOpenOrders: (accountIdArg, marketIdArg, nextPageUrlArg) => {
    return new Promise((resolve, reject) => {
      let disposer;

      const onResult = message => {
        resolve(message);
        disposer();
      };

      const onError = message => {
        reject(message);
        disposer();
      };

      function generateFetchKey({ accountId, marketId, nextPageUrl } = {}) {
        if (nextPageUrl && accountId && marketId) return `openOrders-${marketId}-${accountId}-${nextPageUrl}`;
        if (accountId && marketId) return `openOrders-${marketId}-${accountId}`;
        return `openOrders`;
      }

      disposer = setupDataFetcher(onResult, onError, generateFetchKey, null, {
        accountId: accountIdArg,
        marketId: marketIdArg,
        nextPageUrl: nextPageUrlArg
      });
    });
  },

  getOrders: (accountIdArg, nextPageUrlArg) => {
    return new Promise((resolve, reject) => {
      let disposer;

      const onResult = message => {
        resolve(message);
        disposer();
      };
      const onError = message => {
        reject(message);
        disposer();
      };
      const generateFetchKey = ({ accountId, nextPageUrl } = {}) => {
        if (nextPageUrl && accountId) return `accountOrders-${accountId}-${nextPageUrl}`;
        if (accountId) return `accountOrders-${accountId}`;
        return `accountOrders`;
      };
      disposer = setupDataFetcher(onResult, onError, generateFetchKey, null, {
        accountId: accountIdArg,
        nextPageUrl: nextPageUrlArg
      });
    });
  },

  getBalance: (accountIdParam, assetParam) => {
    return new Promise((resolve, reject) => {
      let disposer;

      const onResult = message => {
        resolve(message);
        disposer();
      };
      const onError = message => {
        reject(message);
        disposer();
      };
      const generateFetchKey = ({ asset, accountId } = {}) =>
        asset && accountId ? `funds-${asset}-${accountId}` : 'funds';
      disposer = setupDataFetcher(onResult, onError, generateFetchKey, 30000, {
        asset: assetParam,
        accountId: accountIdParam
      });
    });
  },

  createOrder: ({ category, pair, side, quantity, price, freeze, tif = 'GOOD_TIL_CANCELED' }) => {
    return context.account().then(account => {
      const baseJson = {
        market: pair,
        side,
        quantity,
        execution: {
          type: category,
          freeze,
          price,
          timeInForce: {
            type: tif,
            value: null
          }
        }
      };
      return post(
        `${baseUrl}/${account.id}/orders`,
        {
          json: baseJson
        },
        account,
        { decamelizeRequestKeys: false, returnHeaders: true }
      ).then(res => {
        const orderId = res.headers.location?.split('/').pop();
        return orderId;
      });
    });
  }
};

export default NBXAccounts;
